import React from 'react'

import { FooterSection } from './styles/footerStyles'

const Footer = () => {
  return (
    <FooterSection>
      <p>App made by &nbsp;
        <a
          href="https://nadialefebvre.dev/"
          target="_blank"
          rel="noopener noreferrer"
          title="Portfolio Nadia Lefebvre">
          Nadia Lefebvre
        </a>
      </p>
    </FooterSection>
  )
}

export default Footer
